import React, { useState } from "react";
import { downloadDocumentBucket } from "lib/axiosUtils";

const FileUploadWidget = (props) => {
  const { onChange, value, label } = props;
  const [fileName, setFileName] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadError, setDownloadError] = useState("");

  const allowedTypes = ["pdf", "png", "jpg", "jpeg"];
  const maxSize = 2 * 1024 * 1024; // 2 MB in bytes

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    const fileType = file.name.split(".").pop().toLowerCase();

    if (!allowedTypes.includes(fileType)) {
      alert("Invalid file type! Only PDF, PNG, JPG, and JPEG are allowed.");
      return;
    }

    if (file.size > maxSize) {
      alert("File size exceeds the 2 MB limit. Please upload a smaller file.");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      if (onChange) {
        onChange(reader.result);
      }
      setFileName(file.name);
    };
    reader.readAsDataURL(file);
  };

  const getDisplayName = () => {
    if (fileName) {
      return fileName;
    }

    if (typeof value === "string" && value) {
      return value.split("/").pop();
    }

    return "";
  };

  const getS3Key = (url) => {
    if (!url) return null;

    const s3UrlPattern = /^https:\/\/([^/]+)\.s3\.amazonaws\.com\/(.+)$/;
    const match = url.match(s3UrlPattern);

    if (match && match[2]) {
      return match[2];
    }

    return url;
  };

  const handleDownload = async (event) => {
    event.preventDefault();

    const s3Key = getS3Key(value);

    if (!s3Key) {
      setDownloadError("Invalid file reference");
      return;
    }

    setIsDownloading(true);
    setDownloadError("");

    try {
      const response = await downloadDocumentBucket({}, { fileKey: s3Key });

      if (!response.data?.downloadUrl) {
        throw new Error("Invalid response from server");
      }

      window.open(response.data.downloadUrl, "_blank");
    } catch (err) {
      console.error("Download failed:", err);
      setDownloadError(err.message || "Failed to generate download link");

      if (typeof value === "string" && value.startsWith("http")) {
        window.open(value, "_blank");
      }
    } finally {
      setIsDownloading(false);
    }
  };

  const canDownload = typeof value === "string" && value.startsWith("http");

  return (
    <div>
      {canDownload && (
        <div>
          <button type="button" onClick={handleDownload} disabled={isDownloading} className="download-link-button">
            {isDownloading ? "Preparing download..." : "Download current file"}
          </button>
          {downloadError && <div style={{ color: "red", marginTop: 4 }}>{downloadError}</div>}
        </div>
      )}
      <input style={{ marginTop: 8 }} type="file" accept=".pdf,.png,.jpg,.jpeg" onChange={handleFileChange} />
      {getDisplayName() && (
        <p style={{ marginTop: 8, marginBottom: 0 }}>
          {typeof value === "string" && value && !fileName && (
            <span style={{ color: "#2268b3" }}>(replace with a new file if needed)</span>
          )}
        </p>
      )}

      {label && !getDisplayName() && <p style={{ marginTop: 8, marginBottom: 0 }}>Choose a file to upload.</p>}
    </div>
  );
};

export default FileUploadWidget;